module.exports = __webpack_public_path__ + "static/media/termsAndConditions.6ffcf302.pdf";